'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageNotFound = exports.PrismaCmsApp = exports.Renderer = exports.App = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _class, _temp; // import Apollo from 'apollo-cms/lib/App';
// import FrontEditor from './components/FrontEditor';


require('./styles/less/styles.css');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Apollo = require('./components/Apollo');

var _Apollo2 = _interopRequireDefault(_Apollo);

var _App = require('./components/App');

var _App2 = _interopRequireDefault(_App);

var _Renderer = require('./components/App/Renderer');

var _ = require('./components/pages/404');

var _2 = _interopRequireDefault(_);

var _reactRouterDom = require('react-router-dom');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var PrismaCmsApp = (_temp = _class = function (_Component) {
  _inherits(PrismaCmsApp, _Component);

  function PrismaCmsApp() {
    _classCallCheck(this, PrismaCmsApp);

    return _possibleConstructorReturn(this, (PrismaCmsApp.__proto__ || Object.getPrototypeOf(PrismaCmsApp)).apply(this, arguments));
  }

  _createClass(PrismaCmsApp, [{
    key: 'render',
    // constructor(props) {
    //   super(props);
    //   const {
    //     // queryFragments,
    //   } = this.props;
    // }
    value: function render() {
      var _props = this.props,
          App = _props.App,
          apolloOptions = _props.apolloOptions,
          endpoint = _props.endpoint,
          other = _objectWithoutProperties(_props, ['App', 'apolloOptions', 'endpoint']);

      if (!endpoint) {
        if (apolloOptions && apolloOptions.endpoint) {
          endpoint = apolloOptions.endpoint;
        } else {
          var _ref = global.location || {},
              protocol = _ref.protocol,
              host = _ref.host;

          endpoint = protocol + '//' + host + '/api/';
        }
      }

      return _react2.default.createElement(_reactRouterDom.BrowserRouter, null, _react2.default.createElement(_Apollo2.default, _extends({
        endpoint: endpoint,
        apiQuery: '{\n          user:me{\n            id\n            username\n            fullname\n            email\n            phone\n            showEmail\n            showPhone\n            sudo\n            hasEmail\n            hasPhone\n          }\n        }\n      '
      }, apolloOptions), _react2.default.createElement(App, other)));
    }
  }]);

  return PrismaCmsApp;
}(_react.Component), _class.propTypes = {
  App: _propTypes2.default.func.isRequired
}, _class.defaultProps = {
  App: _App2.default
}, _temp);
exports.App = _App2.default;
exports.Renderer = _Renderer.Renderer;
exports.PrismaCmsApp = PrismaCmsApp;
exports.PageNotFound = _2.default;
exports.default = PrismaCmsApp;